import React from 'react';
import { FaTimes } from 'react-icons/fa';
import ApplicationDetails from '../HRAdmincontent/ApplicantDetails';

const ApplicationDetailsModal = ({ isModalOpen, selectedApplicant, setIsModalOpen }) => {
  const handleClose = () => {
    setIsModalOpen(false);
  };

  if (!isModalOpen || !selectedApplicant) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleClose}
    >
      <div
        className="bg-white pt-8 p-4 md:p-5 lg:p-2 rounded-lg shadow-md w-full max-w-[92%] md:max-w-[75%] lg:max-w-[70%] relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-1 md:top-2 md:right-2 right-1 text-red-600 text-xl md:text-2xl p-2 hover:bg-gray-200 rounded-full"
          onClick={handleClose}
        >
          <FaTimes />
        </button>
        <div className="overflow-y-auto max-h-[80vh] lg:max-h-[90vh]">
          <ApplicationDetails applicationData={selectedApplicant} />
        </div>
      </div>
    </div>
  );
};

export default ApplicationDetailsModal;
